import { Units } from 'common/types/format';
import { getCurrencyDivisor } from 'utilities/formatNumbers';

export interface UnitAwareInputTarget {
  alias?: string | null;
  row?: number;
  column?: number;
}

export interface UnitAwareInputPolicy {
  getInputScale: (target: UnitAwareInputTarget) => number;
  toActualValue: (target: UnitAwareInputTarget, value: unknown) => unknown;
}

interface CreateUnitAwareInputPolicyOptions {
  enabled: boolean;
  units: Units;
  isEligible: (target: UnitAwareInputTarget) => boolean;
}

export const createUnitAwareInputPolicy = ({
  enabled,
  units,
  isEligible,
}: CreateUnitAwareInputPolicyOptions): UnitAwareInputPolicy => {
  const selectedUnitScale = enabled ? getCurrencyDivisor(units) : 1;
  const getInputScale = (target: UnitAwareInputTarget) =>
    enabled && isEligible(target) ? selectedUnitScale : 1;

  return {
    getInputScale,
    toActualValue: (target, value) => {
      if (value === '' || value === null || value === undefined) {
        return value;
      }

      const numericValue = Number(value);
      if (!Number.isFinite(numericValue)) {
        return value;
      }

      return numericValue * getInputScale(target);
    },
  };
};
